import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useAppSelector } from "@store/hooks";
import { ui } from '../../interfaces/interfaces';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const CADENTModal: React.FC = () => {
    const open = useAppSelector(({ ui }) => ui.CadentModal);
    const handleClose = () => ui.CadentModal = false;

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h4" component="h2" color="red" textAlign="center">
                    <b>IMPORTANT - Gas Leak</b>
                </Typography>
                <Typography id="modal-modal-advise0" sx={{ mt: 2 }}>
                    When advised of a gas escape, the customer should be instructed as follows:
                </Typography>
                <Typography id="modal-modal-advise1" sx={{ mt: 2 }}>
                    - <b>Do NOT smoke.</b>
                </Typography>
                <Typography id="modal-modal-advise2" sx={{ mt: 2 }}>
                    - <b>Do NOT operate electrical light or power switches.</b>
                </Typography>
                <Typography id="modal-modal-advise3" sx={{ mt: 2 }}>
                    - <b>Turn off the gas supply immediately at the meter unless this requires you to turn a light on.</b>
                </Typography>
                <Typography id="modal-modal-advise4" sx={{ mt: 2 }}>
                    - <b>Extinguish all sources of ignition.</b>
                </Typography>
                <Typography id="modal-modal-advise5" sx={{ mt: 2 }}>
                    - If necessary, ventilate the building by opening windows and doors.
                </Typography>
                <Typography id="modal-modal-advise6" sx={{ mt: 2 }}>
                    - Ensure access to the premises can be made.
                </Typography>
                <Typography id="modal-modal-advise7" sx={{ mt: 2 }}>
                    - Report the gas escape to <b>CADENT on 0800 111 999.</b>
                </Typography>
                <Typography id="modal-modal-advise8" sx={{ mt: 2 }}>
                    CADENT will identify the leak and leave premises safe, but will not undertake any repairs.
                </Typography>
                <Typography id="modal-modal-advise9" sx={{ mt: 2 }}>
                    You can then book the customer our Gas Safe Engineer to sort the problem out.
                </Typography>
                <Typography id="modal-modal-advise10" sx={{ mt: 2 }}>
                    If you see this message after customer has been visited by CADENT, please change Required Questions accordingly.
                </Typography>
            </Box>
        </Modal>
    );
}

export default React.memo(CADENTModal);